module.exports = __webpack_public_path__ + "img/custom-survery-active.06dff300.svg";